import { useTranslation } from 'react-i18next';

/**
 * 必要なデータが取得できなかった場合
 * @returns
 */
function NoDataComponent() {
  const { t } = useTranslation();
  return <div>{t('データが取得できませんでした。')}</div>;
}

export default NoDataComponent;
